import React, { useState } from 'react';
import UploadFormTable from '../Reusable/Attachment/UploadFormTable/UploadFormTable';
import { checkFileFormat, getFilesForUpload } from '../../utils/attachment';
import { isEmpty } from 'lodash';
import FormWrapper from '../Reusable/FormWrapper/FormWrapper';
import { basicFormValidationHandler } from '../../utils';

const AttachmentForm = (props) => {
  const { onSubmit, submitRef, allowedFileTypes, Errors } = props || {};
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [errors, setErrors] = useState({});

  const onFileChangeHandler = (e) => {
    const filesForUpload = getFilesForUpload(e.target.files);
    filesForUpload &&
      setUploadedFiles((prevState) => prevState.concat(filesForUpload));
  };

  function onDeleteDocumentHandler() {
    setUploadedFiles([]);
    const errorObject = { ...errors };
    delete errorObject['uploadedFiles'];
    setErrors(errorObject);
  }

  const clientValidationHandler = () => {
    let errorsObject = basicFormValidationHandler(Errors);
    if (uploadedFiles?.length !== 1) {
      errorsObject['uploadedFiles'] = Errors?.uploadedFiles;
    } else if (checkFileFormat(uploadedFiles, [allowedFileTypes])) {
      errorsObject['uploadedFiles'] = `${Errors?.invalidFileFormat}`;
    }
    setErrors(errorsObject);
    return !isEmpty(errorsObject);
  };

  const onSubmitHandler = (event) => {
    event?.preventDefault();

    if (clientValidationHandler()) return;

    const formData = new FormData();
    formData.append('file', uploadedFiles?.[0]);
    onSubmit(formData);
  };

  return (
    <FormWrapper
      submitRef={submitRef}
      noValidate={true}
      onSubmit={onSubmitHandler}
    >
      <UploadFormTable
        name="uploadedFiles"
        onChange={onFileChangeHandler}
        handleDeleteDocument={onDeleteDocumentHandler}
        uploadedFiles={uploadedFiles}
        enableMultiple={false}
        deleteColWidth={'25%'}
        renderButton={true}
        allowedFormats={allowedFileTypes}
        errors={errors}
        errorsHandler={setErrors}
        showButtonAllowedTypes={true}
      />
    </FormWrapper>
  );
};

export default AttachmentForm;
